'use client'
import * as Sentry from '@sentry/nextjs'
import { DeadpoolV2OperationalModel } from '~types/index'

interface SentryTagsProps {
  clientId: string
  storeReference: string
  operationalModel: DeadpoolV2OperationalModel | null
}

const SentryTags = ({
  clientId,
  storeReference,
  operationalModel,
}: SentryTagsProps) => {
  Sentry.setTag('IL-clientId', clientId)
  Sentry.setTag('IL-storeReference', storeReference)
  Sentry.setTag('IL-operationalModel', operationalModel)
  return null
}
export default SentryTags
